import { css, unsafeCSS } from 'lit-element';
import {
  white, gm100, positive400, negative400, n50, n75, n200, n670, g200,
} from '@aab/sc-styles-colors';
import { label } from '@aab/sc-styles-typography';
import { d_inline_block as dInlineBlock } from '@aab/sc-styles-utilities';

const aabInputStyles = css`
  ${unsafeCSS(label)}
  ${unsafeCSS(dInlineBlock)}

/**
** Plain css applicable for input field and label
**/
.form-control {
  display: block;
  width: 100%;
  min-width: 0px;
  height: calc(1.5em + .875rem + 2px);
  padding-left: 8px;
  margin: auto;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${unsafeCSS(n670)};
  background-color: ${unsafeCSS(white)};
  background-clip: padding-box;
  border: none;
  border-radius: .125rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  outline: 0; }

.form-control-plaintext.form-control-lg, .form-control-plaintext.form-control-sm {
  padding-right: 0;
  padding-left: 0; }

.form-control-sm {
  height: calc(1.5em + .5rem + 2px);
  padding: .25rem .5rem;
  font-size: .875rem;
  line-height: 1.5;
  border-radius: .2rem; }

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: .5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: .3rem; }

.form-control::-ms-expand {
  background-color: transparent;
  border: 0; }

.form-control::placeholder {
  color: ${unsafeCSS(gm100)};
  opacity: 1; }
  
.form-control:-ms-input-placeholder {
color: ${unsafeCSS(gm100)};
opacity: 1;}
  
.form-control::-ms-input-placeholder {
  color: ${unsafeCSS(gm100)};
  opacity: 1;}

.form-control:disabled, .form-control[readonly] {
  background-color: ${unsafeCSS(n50)};
  color: ${unsafeCSS(n200)};
  opacity: 1; }

.form-control-file, .form-control-range {
  display: block;
  width: 100%; }

.form-control.is-valid, .was-validated .form-control:valid {
  border-color: ${unsafeCSS(positive400)};
  padding-right: calc(1.5em + .875rem);
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23608e28' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 100% calc(.375em + .21875rem);
  background-size: calc(.75em + .4375rem) calc(.75em + .4375rem); }

.form-control.is-valid:focus, .was-validated .form-control:valid:focus {
  border-color: ${unsafeCSS(positive400)};
  box-shadow: 0 0 0 0.075rem rgba(96, 142, 40, 0.25); }

.form-control.is-valid ~ .valid-feedback, .form-control.is-valid ~ .valid-tooltip, 
.was-validated .form-control:valid ~ .valid-feedback, .was-validated .form-control:valid ~ .valid-tooltip {
  display: block; }

.form-control.is-invalid, .was-validated .form-control:invalid {
  border-color: ${unsafeCSS(negative400)};
  padding-right: calc(1.5em + .875rem);
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23d21b02' viewBox='-2 -2 7 7'%3E%3Cpath stroke='%23d21b02' d='M0 0l3 3m0-3L0 3'/%3E%3Ccircle r='.5'/%3E%3Ccircle cx='3' r='.5'/%3E%3Ccircle cy='3' r='.5'/%3E%3Ccircle cx='3' cy='3' r='.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 100% calc(.375em + .21875rem);
  background-size: calc(.75em + .4375rem) calc(.75em + .4375rem); }

.form-control.is-invalid:focus, .was-validated .form-control:invalid:focus {
  border-color: ${unsafeCSS(negative400)};
  box-shadow: 0 0 0 0.075rem rgba(210, 27, 2, 0.25); }

.form-control.is-invalid ~ .invalid-feedback, .form-control.is-invalid ~ .invalid-tooltip, 
.was-validated .form-control:invalid ~ .invalid-feedback, .was-validated .form-control:invalid ~ .invalid-tooltip {
  display: block; }

.col-form-label {
  padding-top: calc(.4375rem + 1px);
  padding-bottom: calc(.4375rem + 1px);
  margin-bottom: 0; }

.input-group-text {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 0.4375rem 0.4375rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${unsafeCSS(n670)};
  text-align: center;
  white-space: nowrap;
  background-color: ${unsafeCSS(white)};
  border: 1px solid ${unsafeCSS(n75)};
  border-radius: 0.125rem; }

  .input-icon-group {
    border: 1px solid ${unsafeCSS(n75)};
    display: flex; 
    border-radius: 2px;
  }
  
  .input-icon {
    margin-left: -1px;
    border-left: none;
    padding: 8px 8px 6px 8px; }

  .input-icon-group.focused {
    border: 1px solid ${unsafeCSS(g200)};
  }

  .input-icon.disable {
    background-color: ${unsafeCSS(n50)};
  }

  .input-icon-group.is-invalid {
    border-color: ${unsafeCSS(negative400)};
  }
`;

export default aabInputStyles;
